import React, { useEffect, useRef, useState } from 'react';
import Btn from '../../../components/ui/Btn';
import Secao from '../../../components/ui/Secao';
import { documentosApi } from '../../../api/rh';
import { COLORS } from '../../../theme';

function formatarTamanho(bytes) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export default function DocumentosTab({ funcionarioId }) {
  const [documentos, setDocumentos] = useState([]);
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState('');
  const inputRef = useRef(null);

  const carregar = () => documentosApi.listar(funcionarioId).then(setDocumentos).catch(() => {});

  useEffect(() => { if (funcionarioId) carregar(); }, [funcionarioId]); // eslint-disable-line

  if (!funcionarioId) return <p style={{ color: COLORS.textMid, fontSize: 14 }}>Salve o cadastro na aba Dados Pessoais antes de anexar documentos.</p>;

  const enviarArquivo = async (arquivo) => {
    if (!arquivo) return;
    setEnviando(true);
    setErro('');
    try {
      await documentosApi.enviar(funcionarioId, arquivo);
      carregar();
    } catch (e) {
      setErro(e.message);
    } finally {
      setEnviando(false);
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  const excluir = async (id) => {
    if (!window.confirm('Excluir este documento?')) return;
    await documentosApi.excluir(id);
    carregar();
  };

  return (
    <Secao titulo="Documentos Anexados">
      <div
        onClick={() => inputRef.current?.click()}
        onDragOver={e => e.preventDefault()}
        onDrop={e => { e.preventDefault(); enviarArquivo(e.dataTransfer.files[0]); }}
        style={{
          border: `2px dashed ${COLORS.border}`, borderRadius: 10, padding: 24, textAlign: 'center',
          cursor: 'pointer', color: COLORS.textMid, fontSize: 13, marginBottom: 14
        }}
      >
        {enviando ? 'Enviando...' : 'Clique ou arraste um arquivo aqui (PDF, imagem, doc, planilha — até 15MB)'}
        <input ref={inputRef} type="file" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.txt"
          style={{ display: 'none' }} onChange={e => enviarArquivo(e.target.files[0])} />
      </div>

      {erro && <p style={{ color: COLORS.danger, fontSize: 13 }}>{erro}</p>}

      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
        <thead>
          <tr style={{ textAlign: 'left', background: COLORS.bg }}>
            <th style={{ padding: 8 }}>Arquivo</th>
            <th style={{ padding: 8 }}>Tamanho</th>
            <th style={{ padding: 8 }}>Data</th>
            <th style={{ padding: 8 }}></th>
          </tr>
        </thead>
        <tbody>
          {documentos.map(doc => (
            <tr key={doc.id} style={{ borderTop: `1px solid ${COLORS.border}` }}>
              <td style={{ padding: 8 }}>{doc.nome_original}</td>
              <td style={{ padding: 8 }}>{formatarTamanho(doc.tamanho || 0)}</td>
              <td style={{ padding: 8 }}>{new Date(doc.criado_em).toLocaleDateString('pt-BR')}</td>
              <td style={{ padding: 8, display: 'flex', gap: 10 }}>
                <a href={`/uploads/documentos/${funcionarioId}/${doc.nome_arquivo}`} target="_blank" rel="noreferrer" style={{ color: COLORS.primary, fontWeight: 600, fontSize: 12 }}>Ver</a>
                <Btn tamanho="sm" variante="danger" onClick={() => excluir(doc.id)}>Excluir</Btn>
              </td>
            </tr>
          ))}
          {documentos.length === 0 && (
            <tr><td colSpan={4} style={{ padding: 16, textAlign: 'center', color: COLORS.textMid }}>Nenhum documento anexado ainda.</td></tr>
          )}
        </tbody>
      </table>
    </Secao>
  );
}
